<template>
  <div id="add-media" class="m-t-10">
    <div class="alert alert-success" v-if="is_success">
      <i class="bi bi-check-circle"></i>
      Berhasil! {{ tipe == "whitelist" ? "Whitelist" : "Blacklist" }} media
      berhasil ditambahkan.
    </div>
    <div class="alert alert-danger" v-if="is_already_exist">
      <i class="bi bi-check-circle"></i>
      Gagal! Nama media telah terdaftar pada {{ tipe }} media.
    </div>
    <form @submit.prevent="saveMediaList">
      <div class="form-group">
        <label for="input-jenis-media">
          Jenis Media <span class="text-danger">*</span>
        </label>
        <div class="form-group">
          <multiselect
            v-model="jenis_media"
            :options="type_options"
            :allowEmpty="false"
            @input="getListMedia"
            placeholder="Pilih Jenis Media"
            label="title"
            track-by="title"
            :disabled="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="form-group">
        <label for="input-nama">
          Nama Media <span class="text-danger">*</span>
        </label>
        <div class="form-group">
          <multiselect
            v-model="nama_media"
            :options="media_options"
            :searchable="true"
            :allowEmpty="false"
            placeholder="Pilih Nama Media"
            label="nama"
            track-by="nama"
            :taggable="true"
            @tag="addTag"
            :multiple="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button
          type="submit"
          class="btn btn-warning"
          :disabled="!nama_media || !jenis_media"
        >
          Simpan
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import $ from "jquery";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

export default {
  name: "modal_add_media",
  components: {
    Multiselect,
  },
  data() {
    return {
      is_success: false,
      is_already_exist: false,
      is_disabled: true,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      id_user: this.$store.getters.user.user_id.$oid,
      tipe: this.$parent.data_modal.tipe,
      nama_media: null,
      jenis_media: [
        {
          title: "Media Online",
          value: "news",
        },
      ],
      media_options: [],
      type_options: [
        {
          title: "Media Online",
          value: "news",
        },
        // {
        //   title: "Media Cetak",
        //   value: "media_cetak",
        // },
        // {
        //   title: "Media TV",
        //   value: "media_tv",
        // },
      ],
    };
  },
  mounted: function () {
    this.getListMedia();
  },
  methods: {
    getListMedia: function () {
      this.is_disabled = true;
      this.nama_media = null;
      const api =
        process.env.VUE_APP_API_URL +
        "media?page=1&items=10000&source=" +
        this.jenis_media[0].value;
      this.$http
        .get(api)
        .then((res) => {
          this.media_options = res.data.list;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_disabled = false;
        });
    },
    saveMediaList: function () {
      const params = {
        id_project: this.id_project,
        nama_media: this.nama_media.map(media => this.$sanitize(media.nama)),
        source: 'news',
        cakupan: this.nama_media.cakupan ? this.nama_media.cakupan : "nasional",
        tipe: this.tipe,
        id_user: this.id_user,
      };
      const api = process.env.VUE_APP_API_URL + "blacklist-whitelist-media/add";
      this.$http
        .post(api, params)
        .then((res) => {
          if (res.status == 200) {
            this.is_success = true;
            setTimeout(() => {
              this.is_success = false;
            }, 2000);
            if (this.tipe == "whitelist") {
              this.$parent.$parent.getWhitelist();
            } else {
              this.$parent.$parent.getBlacklist();
            }
          }
        })
        .catch(() => {
          this.is_already_exist = true;
          setTimeout(() => {
            this.is_already_exist = false;
          }, 3000);
        });
    },
    addTag: function (new_media) {
      const tag = {
        nama: new_media,
      };
      console.log(new_media)
      this.media_options.push(tag);
      this.nama_media = {
        nama: new_media,
      };
    },
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>